export function RefreshRing({ progress, spinning, dark = false }: { progress: number; spinning: boolean; dark?: boolean }) {
  const r = 9
  const c = 2 * Math.PI * r
  const trackColor = dark ? 'rgba(7,39,89,0.15)' : 'rgba(255,255,255,0.25)'
  const strokeColor = dark ? 'rgb(7 39 89)' : 'white'
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" className="shrink-0">
      <circle cx="12" cy="12" r={r} fill="none" stroke={trackColor} strokeWidth="2" />
      <circle
        cx="12" cy="12" r={r} fill="none" stroke={strokeColor} strokeWidth="2"
        strokeDasharray={c} strokeDashoffset={c * (1 - progress)}
        strokeLinecap="round" transform="rotate(-90 12 12)"
        className={spinning ? '' : 'transition-[stroke-dashoffset] duration-1000 ease-linear'}
      />
    </svg>
  )
}
